import { heartRunnerLoginState } from '../state/heartRunnerLoginState'
import { 
    FETCH_HEARTRUNNER_LOGIN_REQUEST, FETCH_HEARTRUNNER_LOGIN_SUCCESS, 
    FETCH_HEARTRUNNER_LOGIN_ERROR, LOGOUT_HEARTRUNNER_REQUEST 
} from '../actions/heartRunnerLoginAction'


export function heartRunnerLoginReducer(state = heartRunnerLoginState, action) {
    switch (action.type) {
        case FETCH_HEARTRUNNER_LOGIN_REQUEST:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password
            })
        case FETCH_HEARTRUNNER_LOGIN_ERROR:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                message: action.message,
                loginStatus: action.loginStatus,
               
            })
        case FETCH_HEARTRUNNER_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                message: action.message,
                loginStatus: action.loginStatus,
                authTokenId: action.authTokenId,
                adminId: action.adminId,
                organizationId: action.organizationId,
                adminInfo: action.adminInfo,
            })
        case LOGOUT_HEARTRUNNER_REQUEST:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                message: action.message,
                loginStatus: action.loginStatus,
                authTokenId: action.authTokenId,
                adminId: action.adminId,
                organizationId: action.organizationId
            })
        default:
            return state;
    }
} 
